import React, { useState, useEffect } from 'react';
import { Gamepad2, Coins, Trophy, Gift, Flame, Heart, Play, Zap, Star, Sparkles, Music, Puzzle, Swords, Filter } from 'lucide-react';

export const GameCard = ({ game, onPlay, isHovered, onHover }) => {
  const formatNumber = (num) => num >= 1000 ? (num / 1000).toFixed(1) + 'K' : num;

  const getBadgeStyle = (badge) => {
    const base = {
      position: 'absolute',
      top: '15px',
      right: '15px',
      padding: '5px 12px',
      borderRadius: '20px',
      fontFamily: "'Orbitron', monospace",
      fontSize: '0.7rem',
      fontWeight: '700',
      textTransform: 'uppercase',
      animation: badge === 'hot' ? 'pulse 1s ease-in-out infinite' : 'none'
    };
    if (badge === 'hot') return { ...base, background: 'linear-gradient(135deg, #ff4444, #ff0000)', color: '#fff' };
    if (badge === 'new') return { ...base, background: 'linear-gradient(135deg, #00ff88, #00cc66)', color: '#000' };
    if (badge === 'popular') return { ...base, background: 'linear-gradient(135deg, #ffff00, #ffcc00)', color: '#000' };
    return base;
  };

  return (
    <div
      onClick={() => onPlay(game)}
      onMouseEnter={() => onHover(game.id)}
      onMouseLeave={() => onHover(null)}
      style={{
        background: '#12121a',
        borderRadius: '20px',
        overflow: 'hidden',
        position: 'relative',
        cursor: 'pointer',
        transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        border: '1px solid rgba(255, 255, 255, 0.05)',
        transform: isHovered ? 'translateY(-10px) scale(1.02)' : 'translateY(0) scale(1)',
        boxShadow: isHovered ? '0 20px 40px rgba(0, 0, 0, 0.4), 0 0 30px rgba(0, 245, 255, 0.2)' : 'none',
        borderColor: isHovered ? 'rgba(0, 245, 255, 0.3)' : 'rgba(255, 255, 255, 0.05)'
      }}
    >
      <div style={{ width: '100%', height: '180px', position: 'relative', overflow: 'hidden' }}>
        <img
          src={game.thumbnail}
          alt={game.title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'transform 0.5s ease',
            transform: isHovered ? 'scale(1.1)' : 'scale(1)'
          }}
        />
        {game.badge && (
          <span style={getBadgeStyle(game.badge)}>
            {game.badge === 'hot' ? '🔥 HOT' : game.badge === 'new' ? '✨ NEW' : '⭐ POPULAR'}
          </span>
        )}
      </div>
      <div style={{ padding: '20px' }}>
        <h3 style={{
          fontFamily: "'Orbitron', monospace",
          fontSize: '1.3rem',
          fontWeight: '700',
          marginBottom: '8px',
          transition: 'color 0.3s ease',
          color: isHovered ? '#00f5ff' : '#fff'
        }}>
          {game.title}
        </h3>
        <p style={{
          color: 'rgba(255, 255, 255, 0.5)',
          fontSize: '0.9rem',
          marginBottom: '15px',
          lineHeight: '1.5'
        }}>
          {game.description}
        </p>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: '15px' }}>
            <span style={{ display: 'flex', alignItems: 'center', gap: '5px', color: 'rgba(255, 255, 255, 0.4)', fontSize: '0.85rem' }}>
              <Gamepad2 size={16} /> {formatNumber(game.plays)}
            </span>
            <span style={{ display: 'flex', alignItems: 'center', gap: '5px', color: 'rgba(255, 255, 255, 0.4)', fontSize: '0.85rem' }}>
              <Heart size={16} /> {formatNumber(game.likes)}
            </span>
          </div>
          <button style={{
            padding: '10px 25px',
            background: 'linear-gradient(135deg, #00f5ff, #ff00ff)',
            border: 'none',
            borderRadius: '25px',
            color: '#000',
            fontFamily: "'Orbitron', monospace",
            fontSize: '0.85rem',
            fontWeight: '700',
            cursor: 'pointer',
            textTransform: 'uppercase',
            letterSpacing: '2px',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Play size={14} fill="#000" /> Play
          </button>
        </div>
      </div>
    </div>
  );
};